import './about-video.scss';
import type { AboutVideoData } from '../../../interfaces/about';
import SafeHtmlRenderer from '../../../providers/SafeHtmlRender';


function getThumbnailSrc(thumbnail: AboutVideoData['thumbnail']) {
  if (typeof thumbnail === 'string') {
    return thumbnail ? `/api/assets/${thumbnail}?key=original` : '';
  }

  if (thumbnail && typeof thumbnail === 'object') {
    const assetId = String((thumbnail as Record<string, unknown>).id ?? '');
    return assetId ? `/api/assets/${assetId}?key=original` : '';
  }

  return '';
}

export function AboutVideo({ item }: any) {

  if (!item) {
    return null;
  }
  const {description,thumbnail,url} = item;
  const thumbnailSrc = getThumbnailSrc(thumbnail);
  const linkUrl = String(url ?? '');

  return (
    <section className="about-video">
      <div className="about-video-container">
        {thumbnailSrc ? (
          <div className="about-video-media">
            <img src={thumbnailSrc} alt="Illustration vidéo" loading="lazy" />
          </div>
        ) : null}

        <div className="about-video-content text-left">
          {description ? (
            <div className="about-video-description">
              <SafeHtmlRenderer html={description} />
            </div>
          ) : null}

          {linkUrl ? (
            <a className="about-video-link" href={linkUrl} target="_blank" rel="noreferrer">
              {linkUrl}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
